
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23 100.165a13.954 13.954 0 004.1 9.734l45.961 45.962c5.468 5.468 14.332 5.468 19.8 0 5.467-5.467 5.467-14.331 0-19.799L71.48 114.681l89.5.001c7.732 0 14-6.268 14-14s-6.268-14-14-14l-90.901-.001L92.86 63.899c5.468-5.467 5.468-14.331 0-19.798-5.467-5.468-14.331-5.468-19.799 0L27.1 90.062a13.954 13.954 0 00-4.1 9.735z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    